<template>
  <Grid v-if="statuses.length" gtc="repeat(5, 80px)" class="statuses-filter q-ml-sm">
    <Grid
      v-for="status of statuses"
      :key="status.id"
      gaf="column"
      justify-content="center"
      align-items="center"
      class="col"
    >
      <RCheckbox :value="filter" :val="status.name" @input="valueChanged" />
      <div class="status-name text-lowercase-btn text-secondary-1 q-ml-xs">{{ capitalize(status.name) }}</div>
    </Grid>
  </Grid>

  <Grid v-else justify-content="center" style="width: 400px">
    Loading statuses...
  </Grid>
</template>

<script>
import { debounce } from 'lodash'

export default {
  data: () => ({
    filter: []
  }),

  computed: {
    statuses() {
      const vuexModule = this.params.filterParams.vuexModule
      const vuexState = this.params.filterParams.vuexState

      return this.$store.state[vuexModule][vuexState]
    }
  },

  watch: {
    statuses: {
      handler(newVal) {
        if (newVal.length) this.filter = newVal.map(status => status.name)
      },
      immediate: true
    }
  },

  methods: {
    changeFilter: debounce(function(value) {
      this.params.parentFilterInstance(function(instance) {
        instance.onFloatingFilterChanged('contains', value, 'list_names')
      })
    }, 800),

    valueChanged(newValue) {
      let value
      if (newValue.length === this.statuses.length) value = null
      else value = [...newValue]

      if (value) this.filter = [...value]
      else this.filter = this.statuses.map(status => status.name)

      this.changeFilter(value)
    },

    onParentModelChanged(parentModel) {
      if (parentModel) this.filter = parentModel.filter
      else this.filter = this.statuses.map(status => status.name)
    }
  }
}
</script>

<style lang="scss" scoped>
.statuses-filter {
  height: 100%;

  .col:last-child > .status-name {
    margin-right: 3px;
  }
}
</style>
